
















































import { useQuery, useResult } from '@vue/apollo-composable';
import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter } from 'vivat';

import getDrivers from '@/gql/driver/getDrivers.gql';

import { PaginatorInfo } from '@/types/paginatorInfo';
import useAuth from '@/useAuth';

const Driver = defineComponent({
  setup() {
    const { route, router } = useRouter();
    const { me } = useAuth();

    const filterDriverDropdown = ['ชื่อ/นามสกุล', 'something'];
    const filterDriverValues = ['name', 'something'];
    const selectedFilterDriver = ref('ชื่อ/นามสกุล');
    const selectedFilterDriverValue = computed(() => filterDriverValues[filterDriverDropdown.indexOf(selectedFilterDriver.value)]);

    const search = reactive({
      driverName: '',
      driverSearchInput: '',
      pendingDriverSearch: false,
    });

    const driverNameSearchHandler = _.debounce(() => {
      search.pendingDriverSearch = true;
      search.driverName = search.driverSearchInput;
    }, 500);

    const drivers: Ref<any> = ref([]);
    const driverPaginatorInfo: Ref<PaginatorInfo> = ref({});
    const driversPage = ref(1);
    const { result: getDriverResult, loading: driversLoading } = useQuery(getDrivers, computed(() => ({
      page: driversPage.value,
      trashed: 'WITH',
      searchName: search.driverName !== '' ? `%${search.driverName}%` : undefined,
    })), () => ({ fetchPolicy: 'network-only' }));
    const driversResult = useResult(getDriverResult, [], (data) => data.drivers);
    watch(() => driversResult.value, (newVal, oldVal) => {
      if (!driversLoading.value && newVal !== oldVal) {
        if (search.pendingDriverSearch || driversResult.value.paginatorInfo.currentPage === driverPaginatorInfo.value.currentPage) {
          drivers.value = [];
          drivers.value = driversResult.value.data;
          driversPage.value = 1;
          search.pendingDriverSearch = false;
        } else drivers.value = [...drivers.value, ...driversResult.value.data];
        driverPaginatorInfo.value = driversResult.value.paginatorInfo;
      }
    });

    const selectDriverHandler = (id: any) => {
      if (!(route.value.params.id === id)) router.push({ name: 'SettingEditDriver', params: { id } });
      return false;
    };

    return {
      me,
      filterDriverDropdown,
      selectedFilterDriver,

      search,
      driverNameSearchHandler,

      drivers,
      driverPaginatorInfo,

      selectDriverHandler,
    };
  },
});

export default Driver;
